//Dropdown Nav
jQuery(function ($) {
  $(".menu li a").click(function () {
    $(".menu li")
      .not($(this).parent())
      .removeClass("active");
    $(this).parent().toggleClass("active");
  });

  $(document).click(function (e) {
    $('.menu li')
      .not($('.menu li').has($(e.target)))
      .removeClass('active');
  });

});
